module.exports = __webpack_public_path__ + "static/usluge_04-45cdd18630b742a4bf74fec81111ffb5.jpg";